
export const logoutUser = () => {
  // Clear cookies
  sessionStorage.removeItem('authState');
  sessionStorage.setItem('logoutMessage', 'Session expired. Please log in again.');

  document.cookie = "authState=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  // Redirect
  window.location.href = '/auth/login';
};